<template>
    <CenterBox
        :pageID="0"
    >
        <h1 style="text-align: center">{{ $t("licence_title") }}</h1>
        <form class="center-box-form d-flex flex-column justify-content-center align-items-center" @submit.prevent="submitForm">
            <div class="mb-3">
                <p class="error-text" v-if="error">{{error}}</p>
                <label for="licenceInput" class="form-label">{{ $t("licence_subTitle") }}</label>
                <input type="text" class="form-control" id="licenceInput"
                       aria-describedby="licenceHelp" :placeholder='$t("licence_subTitle")'
                       v-model="licenceKey"
                >
                <div id="licenceHelp" class="form-text">{{ $t("licence_help") }}</div>
            </div>
            <button type="submit" class="btn btn-primary" style="width: 50%">{{ $t("common_submit") }}</button>
        </form>
    </CenterBox>
</template>

<script>
import CenterBox from "@/components/routerViewLocation/CenterBox";
export default {
    name: "SystemLicenseView",
    components: {
        CenterBox
    },
    data(){
        return{
            permissionDetails: {},
            licenceKey: '',
            error: '',
        }
    },
    methods: {
        submitForm(){
            this.checkLicence(this.licenceKey)
        },
        async getBackendData(){
            this.$store.commit('setIsTopLoading', true)
            await this.$mainApi.get('/api/client/license/')
                .then(response => {
                    this.$store.commit('setIsTopLoading', false)
                    if(response.data.status === 80){
                        // Success get licence from client backend
                        this.licenceKey = response.data.details
                        this.checkLicence(this.licenceKey)
                    }else{
                        // Cannot get Licence from client backend
                        this.error = this.$t('licence_error')
                    }
                })
            this.$store.commit('setIsTopLoading', false)
        },
        async checkLicence(key){
            this.$store.commit('setIsTopLoading', true)
            let postData = {
                "key": key
            }
            await this.$mainApi.post('/api/client/license/', postData)
                .then(response => {
                    if(response.data.status === 80) {
                        this.$toast.success(this.$t('licence_toast_detail'));
                        this.licenceKey = response.data.details
                    }else{
                        // Client Save License Key Error
                        this.$swal.fire({
                            title: this.$t('licence_save_client_error'),
                            text: response.data.errors,
                            icon: 'warning',
                        })
                    }
                })
            this.$store.commit('setIsTopLoading', false)
        }
    },
    mounted(){
        document.title = this.$t('title') + ' | ' + this.$t('licence_title')
        this.getBackendData()
    }
}
</script>

<style scoped>

</style>
